module.exports = __webpack_public_path__ + "img/whiteCardWave.9aa4b6dd.svg";